export function mapAndFlattenApproverGroups(response: any) {
  const groups = response?.approverGroupsByUser?.approverGroups || []

  return groups?.flatMap((group: any) => {
    const { approvers, ...restGroup } = group
    if (!approvers?.length) return []
    return approvers.map((approver: any) => ({
      ...restGroup,
      ...approver,
      countryCodes: approver.countryCodes || null,
    }))
  })
}
